import {
  SearchOutlined,
} from '@ant-design/icons';

import "../App.css";
import Papa from 'papaparse';

import React, {
  useState,
  useEffect
} from 'react';

import "../App.css";

import {
  Alert,
  notification,
  Select,
  message,
  Input,
  Button,
  InputNumber,
  Form,
  Table,
} from "antd"

import {
  db
} from '../firebase/firebase'
import { auth } from '../firebase';
import moment from 'moment';


const key = 'updatable';

const data = [

  {
    title: 'Note',
    content: 'units: 12 keys + 1 id = 13 TOTAL FIELDS all string.'
  },
  {
    title: 'Others',
    content: ''
  },
];

const Option2 = Select.Option;

const success = (x) => {
  message.success(x);
};

const error = () => {
  message.error('This is a message of error');
};

const warning = () => {
  message.warning('This is message of warning');
};
const load = (x) => {
  message.loading(x);
}


// state = {
//   msglist: [],
//   count: 0,
//   searchText: '',
//   data: [],
//   major: [],
//   editingKey: '',
//   tempStatus: '',
//   ta: null,
//   xa: null,
//   ya: null,
//   sa: null,
//   ca: null
// };


// <EditableContext.Consumer>
//   {(form) => {
//     const { getFieldDecorator } = form;
//     return (
//       <td {...restProps}>
//         {editing ? (
//           <FormItem style={{ margin: 0 }}>
//             {getFieldDecorator(dataIndex, {
//               rules: [{
//                 required: false,
//                 message: `Please Input ${title}!`,
//               }],
//               initialValue: record[dataIndex],
//             })(getInput())}
//           </FormItem>
//         ) : restProps.children}
//       </td>
//     );
//   }}
// </EditableContext.Consumer>


const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: false,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const Landing = (props) => {
  useEffect(() => {
    pullFromDB()

    auth.onAuthStateChanged((user) => {
      if (user) {
        setEmail(user.email)
      }
    });
  }, []);

  const [form] = Form.useForm();
  const [data, setData] = useState(data);
  const [editingKey, setEditingKey] = useState('');
  const [pendingData, setPendingData] = useState({ disabled: true, inputDisabled: false });

  const [email, setEmail] = useState('');

  const [count, setCount] = useState('');
  const [msglist, setMsglist] = useState([]);
  const [major, setMajor] = useState([]);
  const [tempStatus, setTempStatus] = useState('');






  const selector = (key, value) => {
    // data[key].isSold = value;
    setTempStatus(value)
  }

  const deleteProject = async (id) => {
    // alert("record.key: " + id + "todo id: " + data[id].id)
    await db
      .collection("units")
      .doc(data[id].id)
      .delete();
  }

  const addProject = async () => {
    var na = moment()
    await db.collection("units").add({
      projects: props.match.params.id,
      unittype: "test",
      lot: "test",
      unitno: "test",
      size: "123",
      price: "123",
      customer: "test",
      outline: "-",
      isSold: "Open",
    });
  }







  const isEditing = (record) => record.key === editingKey;


  const edit = (record) => {
    var tempB = data[record.key].isSold
    form.setFieldsValue({
      filename: '',
      startdate: '',
      ...record,
    });
    setEditingKey(record.key);
    setTempStatus(tempB)

  };

  const cancel = () => {
    setEditingKey('');
    // show = false

  };


  const save = async (key) => {
    if (!navigator.onLine)
      return

    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });

        try {

          if (!/^-?\d*[.,]?\d{0,2}$/.test(newData[index].price)) {
            message.error('Numbers only. Decimal point is allowed.')
            return
          }
          load('Updating..', 0)
          newData[index].isSold = tempStatus

          let rr = await db
            .collection("units")
            .doc(data[index].id).update({
              projects: newData[index].projects,
              unittype: newData[index].unittype,
              landarea: newData[index].landarea,
              lot: newData[index].lot,
              unitno: newData[index].unitno,
              size: newData[index].size,
              price: newData[index].price,
              customer: newData[index].customer,
              outline: newData[index].outline,
              isSold: newData[index].isSold,
            })
          success('Successfully updated [Price: ' + newData[index].price + '] [Customer: ' + newData[index].customer + '] [Status: ' + newData[index].isSold + ']')
          setData(newData)
          setEditingKey('');

        } catch (error) {
          message.error(error.message);
        }

      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
          </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
          </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })


  const pullFromDB = () => {
    // We listen for live changes to our data collection in Firebase
    db.collection("units").onSnapshot(snapshot => {
      //data is locally available array, pulled from firestore.
      let data = [];

      let arr = []
      setMsglist(arr)

      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);



        if (typeof todo.projects === 'undefined' || todo.projects == '' || typeof todo.projects !== 'string')
          alerty('undefined projects ' + todo.id)
        if (typeof todo.unittype === 'undefined' || todo.unittype == '' || typeof todo.unittype !== 'string')
          alerty('undefined unittype ' + todo.id)
        if (typeof todo.landarea === 'undefined' || todo.landarea == '' || typeof todo.landarea !== 'string')
          alerty('undefined landarea ' + todo.id)
        if (typeof todo.lot === 'undefined' || todo.lot == '' || typeof todo.lot !== 'string')
          alerty('undefined lot ' + todo.id)
        if (typeof todo.unitno === 'undefined' || todo.unitno == '' || typeof todo.unitno !== 'string')
          alerty('undefined unitno ' + todo.id)
        if (typeof todo.size === 'undefined' || todo.size == '' || typeof todo.size !== 'string')
          alerty('undefined size ' + todo.id)
        if (typeof todo.price === 'undefined')
          alerty('undefined price ' + todo.id)
        if (typeof todo.customer === 'undefined')
          alerty('undefined customer ' + todo.id)
        if (typeof todo.outline === 'undefined' || todo.outline == '' || typeof todo.outline !== 'string')
          alerty('undefined outline ' + todo.id)
        if (typeof todo.isSold === 'undefined' || todo.isSold == '' || typeof todo.isSold !== 'string')
          alerty('undefined isSold ' + todo.id)

      });

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }



      // Anytime the state of our database changes, we update state
      // setState({ data, count: data.length });
      setData(data)
      setCount(data.length)

    })
  }


  const columns = [
    {
      title: '',
      dataIndex: 'operation',
      // fixed: 'left',
      render: (text, record) => {
        const editable = isEditing(record);
        return (
          <div>
            {editable ? (
              <span>
                <Button
                  href="javascript:;"
                  onClick={() => save(record.key)}
                  style={{
                    marginRight: 8,
                  }}
                >
                  Save
          </Button>
                <Button type="primary" onClick={() => cancel(record.key)}>Cancel</Button>
              </span>
            ) : (
              <div>
                <Button
                  onClick={() => edit(record)}
                  className="App-t"
                >
                  Edit
              </Button>
                {/* THIS IS THE DELETE BUTTON (TURNED OFF BY REQUEST) */}
                {/* <Divider type="vertical" />
                  <Popconfirm
                    title="Confirm Delete?"
                    onConfirm={evt => deleteProject(record.key)}
                  >
                    <Button>Delete</Button>
                  </Popconfirm> */}

              </div>
            )}
          </div>
        );
      },
    },
    {
      title: '',
      dataIndex: 'key',
      ...getColumnSearchProps('key'),
      editable: false,
    },
    {
      title: 'doc_id',
      dataIndex: 'id',
      ...getColumnSearchProps('id'),
      editable: false,
    },
    {
      title: 'projects',
      dataIndex: 'projects',
      ...getColumnSearchProps('projects'),
      editable: true,
    },
    {
      title: 'unittype',
      dataIndex: 'unittype',
      ...getColumnSearchProps('unittype'),
      editable: true,
      sorter: (a, b) => { return a.unittype.localeCompare(b.unittype) },
    },
    {
      title: 'landarea',
      dataIndex: 'landarea',
      ...getColumnSearchProps('landarea'),
      editable: true,
      sorter: (a, b) => parseInt(a.landarea, 10) - parseInt(b.landarea, 10),
    },
    {
      title: 'lot',
      dataIndex: 'lot',
      ...getColumnSearchProps('lot'),
      editable: true,
      sorter: (a, b) => { return a.lot.localeCompare(b.lot) },
    },
    {
      title: 'unitno',
      dataIndex: 'unitno',
      ...getColumnSearchProps('unitno'),
      editable: true,
      sorter: (a, b) => { return a.unitno.localeCompare(b.unitno) },
    },
    {
      title: 'size',
      dataIndex: 'size',
      ...getColumnSearchProps('size'),
      editable: true,
      sorter: (a, b) => parseInt(a.size, 10) - parseInt(b.size, 10),
      onHeaderCell: (column) => {
        return {
          onClick: () => {
            console.log('onClick');
          }
        };
      }
    },
    {
      title: 'price',
      dataIndex: 'price',
      ...getColumnSearchProps('price'),
      editable: true,
      sorter: (a, b) => parseInt(a.price, 10) - parseInt(b.price, 10),
    },
    {
      title: 'customer',
      dataIndex: 'customer',
      ...getColumnSearchProps('customer'),
      editable: true,
      sorter: (a, b) => a.customer.length - b.customer.length,
    },
    {
      title: 'outline',
      dataIndex: 'outline',
      ...getColumnSearchProps('outline'),
      editable: true,
      sorter: (a, b) => a.outline.length - b.outline.length,
    },
    {
      title: 'isSold',
      dataIndex: 'isSold',
      width: '10%',
      filters: [{
        text: 'Sold',
        value: 'Sold',
      }, {
        text: 'Open',
        value: 'Open',
      }],
      filterMultiple: false,
      onFilter: (value, record) => record.isSold.indexOf(value) === 0,
      render: (text, record) => {
        const editable = isEditing(record);

        return (
          <div>
            {editable ? (
              <div>
                <Select style={{ width: 120 }} defaultValue={data[record.key].isSold} onChange={(value) => selector(record.key, value)}>
                  <Option2 value="Open">Open</Option2>
                  <Option2 value="Sold">Sold</Option2>
                </Select>
              </div>
            ) : (
              <div>
                {data[record.key].isSold}
              </div>
            )}
          </div>
        );
      },
    },

  ];

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    // setState({ searchText: selectedKeys[0] });
  }


  const handleReset = (clearFilters) => {
    clearFilters();
    // setState({ searchText: '' });
  }

  //===
  


  const loadtheresult = (file) => {
    Papa.parse(file, {
      header: true,
      complete: function (results) {
        var a = results.data
        console.log("Finished:", a);

        (async function loop() {
          for (let i = 0; i < a.length; i++) {
            if (a[i].doc_id.length > 0) {
              let bb = i + 1
              let cc = a.length - 1

              notification.open({
                key,
                message: 'Importing...',
                description: 'setting ' + bb + '/' + cc,
              });

              await new Promise((resolve, reject) => {
                console.log('processing ' + a[i].doc_id)
                db.collection('units').doc(a[i].doc_id).set({
                  projects: a[i].projects,
                  unittype: a[i].unittype,
                  landarea: a[i].landarea,
                  lot: a[i].lot,
                  unitno: a[i].unitno,
                  size: a[i].size,
                  price: a[i].price,
                  customer: a[i].customer,
                  outline: a[i].outline,
                  isSold: a[i].isSold,
                }, { merge: true }).then(resolve).catch((err) => {
                  message.error('Error getting documents' + err.message);
                });
              });

            }
          }
          notification.destroy()
          message.success("Uploaded successfully")
        })();



        // try {
        //   var ss = await db.collection('units').doc(a[i].doc_id)
        //   ss.set({
        //     key: '42'
        //   }, { merge: true });
        //   console.log("end")
        // }
        // catch (err) {
        //   console.log('Error getting documents', err);
        // }




      }
    });
  }

  const handlefile = (event) => {
    if (event.target.files[0]) {
      console.log('Parameter' + event.target.files[0].type);
      if (true) {
        console.log("accepted file format")
        if (event.target.files[0].size < 100000000) {
          console.log(event.target.files[0])
          var file = event.target.files[0];
          loadtheresult(file);
        } else {
          message.error("File is too big!");
        }
      } else {
        message.error("Not the accepted file type!");
      }
    } else {
      message.error("No file in it!");
    }
  }


  const alerty = (msg) => {
    let a = <Alert message={msg} type="error" />
    let arr = [...msglist]
    arr.push(a)
    setMsglist(arr)
  }
  //===

 

  const exportFile = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      error('This feature is only on PC.')
    } else {
      setMajor([])
      var i;
      for (i = 0; i < data.length; i++) {
        var lol = [
          data[i].id,
          data[i].projects,
          data[i].unittype,
          data[i].landarea,
          data[i].lot,
          data[i].unitno,
          data[i].size,
          data[i].price,
          data[i].customer,
          data[i].outline,
          data[i].isSold
        ];
        major.push(lol)
      }

      // console.log(major)
      // alert("the string: " + major.toString())
      success('Downloading ' + major.length + " records...")
      if (major.length > 1)
        downloadcsv();
    }
  }
  
  const downloadcsv = (e) => {
    // console.log("heyy2 " + major);
    var csv = `doc_id,projects,unittype,landarea,lot,unitno,size,price,customer,outline,isSold,\n`
    major.forEach(function (row) {
      csv += row.join(',');
      csv += "\n";
    });
    
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = 'units.csv';
    hiddenElement.click();
  }

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'price' ? 'text' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <div>
      <h1 className="block">admin ({count} units)</h1>
      {msglist}
      <div className="csvbtn" >
        <Button onClick={exportFile}>Export to CSV</Button>
      </div>
      <hr></hr>
      <h3>Import Units CSV Only</h3>
      <div><input type="file"
        accept="text/csv"
        onChange={handlefile}
      /><hr></hr><p>Use the export format, do not omit any columns.<br></br>Matching doc_id, it will update the fields, if not matching doc_id, it will create a new one with the correesponding fields.
  </p></div>

      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          pagination={{ pageSize: 10 }}
          rowClassName="editable-row"
          pagination={{
            onChange: cancel,
          }}
          scroll={{ x: 1500 }}
          className='admintable'
        />
      </Form>

    </div>
  );
};

export default Landing;






// WEBPACK FOOTER //
// ./src/views/landing.js